import React, { useCallback, useMemo } from 'react';
import MaskedInput from 'react-text-mask';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';

const Input = ({ isMasked = false, inputMode = 'numeric', autoFocus = false, name, className, label, hookForm, validate, placeholder, onCustomChange, registerOptions }) => {
  const { formState: { errors }, register, control } = hookForm;

  const cn = useMemo(() => `border ${errors && errors[name] ? 'border-[#ff0000] focus:border-[#ff0000]' : 'border-[#dbe3eb] focus:border-[#008AEA]'} rounded-[3px] w-full h-[46px] p-3 outline-none mt-[13px] transition-all duration-500`, [errors]);

  const handleChange = useCallback((e, onChange) => {
    onChange(e);
    if (onCustomChange) {
      onCustomChange(e);
    }
  }, []);

  return (
    <div className={`mt-[18px] ${className || ''}`}>
      <div className="text-left font-bold text-[14px] leading-[16px] text-[#000A2F] tracking-tight">
        {label}
      </div>
      {isMasked
        && (
        <Controller
          name={name}
          control={control}
          rules={{ validate }}
          render={({ field: { onChange, onBlur, value } }) => (
            <MaskedInput
              inputMode={inputMode}
              autoFocus={autoFocus}
              id={name}
              name={name}
              mask={isMasked}
              className={cn}
              value={value}
              placeholder={placeholder || ''}
              onChange={(e) => handleChange(e, onChange)}
              onBlur={onBlur}
            />
          )}
        />
        )}
      {!isMasked
        && (
        <input
          autoFocus={autoFocus}
          id={name}
          name={name}
          type="text"
          className={cn}
          {...register(name, registerOptions)}
        />
        )}
      {errors && errors[name]
        && (
        <div className="text-[#d71f28] text-xs mt-2">
          {errors[name]?.message}
        </div>
        )}
    </div>

  );
};

Input.propTypes = {
  className: PropTypes.string,
  label: PropTypes.node,
  placeholder: PropTypes.string,
  isMasked: PropTypes.any,
  hookForm: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  autoFocus: PropTypes.bool,
  inputMode: PropTypes.string,
  validate: PropTypes.func,
  onCustomChange: PropTypes.func,
  registerOptions: PropTypes.object,
};

Input.defaultProps = {
  className: '',
  label: null,
  placeholder: '',
  isMasked: false,
  inputMode: 'numeric',
  onCustomChange: null,
  autoFocus: false,
  registerOptions: {},
  validate: null,
};

export default Input;
